import { Items } from 'common/components';
import { PurchaseStatus } from 'common/modules/app/purchase';

import React from 'react';

interface Props {
  /** 画面リスト */
  items: {
    id: string;
    text: string;
    select: true | false;
    onClick: () => void;
  }[];
  /** 選択されている画面 */
  selectedPurchase: PurchaseStatus;
}

/**
 * 契約中プラン一覧画面と購入履歴画面の共通ヘッダー部のコンポーネント
 */
export const PurchaseHeader: React.FC<Props> = ({
  items,
  selectedPurchase
}) => {
  // Historyに渡すpropsを生成
  const _props = {
    items,
    selectedLanguage: '',
    selectedRegion: '',
    selectedCountry: '',
    selectedPurchase
  };
  return (
    <div id="pageHeader" data-test="purchaseHeder">
      <Items type="purchase" {..._props} data-test="history-items" />
    </div>
  );
};
